import React from 'react';
import { useTranslation } from 'react-i18next';

const BasicPage = ({ titleKey, titleFallback, subtitleKey, subtitleFallback, children }) => {
  const { t, i18n } = useTranslation();
  const language = i18n.language || 'en';
  
  // Get titles and subtitles based on language
  const title = t(titleKey, titleFallback);
  const subtitle = t(subtitleKey, subtitleFallback);

  return (
    <div className="min-h-screen py-16 bg-gradient-to-br from-white to-hemp-green-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 p-6 bg-white rounded-2xl shadow-lg">
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-900 mb-4 tracking-tight">
            {title}
          </h1>
          <p className="text-xl text-gray-700 font-medium">
            {subtitle}
          </p>
        </div>
        
        <div className="bg-white rounded-2xl shadow-xl p-8">
          <div className="prose prose-lg max-w-none text-gray-700">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BasicPage;